import { Box, type BoxProps } from '@mantine/core'
import clsx from 'clsx'

import { type CoreItem } from '@flecto/types'

import { useStoreItemAvailabilityList } from '../../hooks/useStoreItemAvailabilityList'
import { CardItem } from '../CardItem/CardItem'
import styles from './styles.module.css'

export type ListItemsProps = BoxProps & {
  items?: CoreItem[]
  itemsPerRow?: number
}

export function ListItems({ items, ...props }: ListItemsProps) {
  const classes = clsx(styles.wrapper, props.className)

  const { data, isLoading } = useStoreItemAvailabilityList({ items })

  return (
    <Box {...props} className={classes}>
      <Box className={styles.list}>
        {data?.map((item) => (
          <CardItem
            item={item}
            isLoadingAvailability={isLoading}
            className={styles.item}
            key={item.id}
          />
        ))}
      </Box>
    </Box>
  )
}
